<template>
  <layout-content>
    <tabs
      type="card"
      :animated="false"
      :value="$route.params.type"
      @on-click="$router.push({ to: 'phone-number.stats.type', params: { type: $event } })"
    >
      <tab-pane
        v-for="tab in ['general', 'detailed']"
        :key="tab"
        :name="tab"
        :label="$t(`shared.breadcrumb.stats.${tab}`)"
      />
    </tabs>

    <component :is="`stats-${$route.params.type}`" />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    components: {
      'stats-general': () => import('@phone-number/pages/numbers-stats-general'),
      'stats-detailed': () => import('@phone-number/pages/numbers-stats-detailed')
    },

    watch: {
      '$route.params.type': {
        handler: function () {
          this.add_breadcumbs({
            item: {
              title: `shared.breadcrumb.stats.${this.$route.params.type}`,
              route: {
                name: 'phone-number.stats.type',
                params: { type: this.$route.params.type }
              }
            }
          });
        },

        immediate: true
      }
    },

    created() {
      this.getList();
    },

    methods: {
      ...mapActions('phone-number/user_countries/list', ['getList']),
      ...mapActions('shared/breadcrumbs', { add_breadcumbs: 'add_item' })
    }
  };
</script>
